module.exports = __webpack_public_path__ + "img/small-logo.a96a596d.png";